var _a;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions } from '@/store/enums/hrgs/UploadEnum';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    getAll: `${API_URL}/api/upload`
};
let UploadModule = class UploadModule extends VuexModule {
    // *ACTIONS
    [_a = Actions.UPLOAD_IMAGE](payload) {
        const params = {
            ver: 'v1',
            isImage: typeof payload.isImage === 'undefined' ? true : payload.isImage
        };
        const formdata = new FormData();
        formdata.append('request', payload.request);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.getAll}/image?${new URLSearchParams(params).toString() || ''}`, formdata)
                .then((resp) => {
                if (resp.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: resp.data.result.message });
                    reject();
                }
                else {
                    const resData = resp.data.result.content;
                    resolve(resData);
                }
            })
                .catch((error) => {
                var _b;
                hrgsSwalAlert({
                    icon: 'error',
                    text: ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.statusText) || 'Failed upload image.'
                });
                reject(error);
            });
        });
    }
};
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UploadModule.prototype, _a, null);
UploadModule = __decorate([
    Module
], UploadModule);
export default UploadModule;
